<div [formGroup]="inputForm" class="grid items-center gap-4 grid-cols-11 text-center p-1 focus-within:bg-segeslightblue80">
  <div class="col-span-1 text-2xl font-bold">{{ animalWeighingViewModel().pen.name }}</div>
  <div class="col-span-1 text-2xl">{{ animalWeighingViewModel().group.name }}</div>
  <div class="col-span-1 text-2xl">{{ animalWeighingViewModel().feed.name }}</div>
  <div class="col-span-1"></div>
  <div class="col-span-2">
    <input
      [decimals]="0"
      class="w-2/3 text-4xl text-center bg-white border rounded-xl"
      matInput
      [min]="1"
      [max]="99"
      [minValue]="1"
      [maxValue]="99"
      InputPositiveInteger
      type="text"
      inputmode="numeric"
      formControlName="numberOfAnimals">
  </div>
  <div class="col-span-2">
    <input
      [decimals]="1"
      class="w-2/3 text-4xl text-center bg-white border rounded-xl "
      matInput
      [min]="0.1"
      [max]="999.9"
      [minValue]="0.1"
      [maxValue]="999.9"
      InputPositiveInteger
      type="text"
      inputmode="numeric"
      formControlName="animalsWeight">
  </div>
  <div class="col-span-1"></div>
  <div class="col-span-2 text-2xl items-center {{ this.isOutlier() ? 'bg-red-500' : '' }}">
    @let averageWeight = this.getAverageWeight();
    {{ averageWeight !== 0 ? averageWeight : '' }}
  </div>
